<template>
  <div class="nup_main">
    <div class="new_content">
      <div class="new_webposition"><router-link :to="{ path: '/usercenter'}">学习中心</router-link><span class="nje_jiange">&gt;</span><span class="nje_last">我的练习</span></div>
      <el-tabs v-model="activeName1" type="card" @tab-click="handleClick" style="margin-top:20px;">
        <el-tab-pane label="培训班练习" name="first">
          <!--培训班练习 ：练习列表-->
          <practise-table-page :bindType="bindType"></practise-table-page>
        </el-tab-pane>
        <el-tab-pane label="我的练习" name="second">
          <!--我的练习 ：练习列表-->
          <practise-table-page :bindType="bindType"></practise-table-page>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>
  import  practiseTablePage from '../../components/PractiseTablePage.vue'

    export default {
      components: {
        practiseTablePage
      },

      data () {
          return {
            bindType:'2',
            activeName1:'first',
            practiseListInit:[],
            listLoading:false,
            openPractiseVisible:false,
            serverTime:'',
            practiseId:'',
            searchForm:{
              page: 1,//当前页数
              pageSize: 10,//每页显示条目个数
              total: 0, //总条目数
              state:'',
              psort:'',
              keyWord:'',
              userId:''
            },
          }
      },
      computed: {
      },
      methods: {
        handleClick(tab){
          if(tab.label=='培训班练习'){
            this.bindType='2';
          }else if(tab.label=='我的练习'){
            this.bindType='1';
          }
        },
      },
      mounted () {
      },
    }

</script>



// WEBPACK FOOTER //
// src/views/usercenter/MyPractise.vue